import { AdvocateTag, nullable, withFallback } from '@infl-ts/util-io-ts';
import * as t from 'io-ts'; // Atlas tag codecs come from the shared util so the popover and the
// full profile-block can't drift apart.

export { AdvocateTag, Taxonomy, TaxonomyTerm } from '@infl-ts/util-io-ts';
var MemberConfig = t.type({
  id: t.string,
  name: t.string,
  isAdmin: t["boolean"],
  title: nullable(t.string),
  company: nullable(t.string),
  level: nullable(t.type({
    name: t.string
  })),
  avatarUrl: nullable(t.string),
  // Wrapped in withFallback for the same reason as the full profile-block:
  // resolver failure -> 0 chips, not a 500 cascade through the popover.
  tags: withFallback(t.array(AdvocateTag), [])
});
export var MemberQuery = t.type({
  member: MemberConfig,
  currentUser: t.type({
    id: t.string,
    isAdmin: t["boolean"]
  })
});
export var MemberQueryVariables = t.type({
  memberId: t.string
});